(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const collapseFooterSections = () => {
    if (!mobileQuery.matches) return;

    document.querySelectorAll('footer details[open]').forEach((details) => {
      details.removeAttribute('open');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collapseFooterSections, { once: true });
  } else {
    collapseFooterSections();
  }

  mobileQuery.addEventListener?.('change', collapseFooterSections);
})();
